define('shoptheme/components/layout/equal-heights',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"json!shoptheme/etc/breakpoints.json",
	"enquire"
], function(
	$,
	_,
	Component,
	BEM,
	BreakPoints,
	enquire
) {
	var COMPONENT_SELECTOR = '.js-equal-heights';
	var COMPONENT_CONFIG_KEY = 'equal-heights';
	var COMPONENT_INSTANCE_KEY = 'equalheights/instance';

	var DEFAULTS = {
		childSelector: '>*',
		heightContainer: null
	};

	var EqualHeights = function(container, config) {
		var self = this;

		this.container = $(container);
		this.containerWidth = this.container.width();
		this.config = $.extend({}, DEFAULTS, config);
		this.elements = [];

		this.container.find(this.config.childSelector).each(function() {
			var child = $(this);

			self.elements.push({
				child: child,
				heightContainer: self.config.heightContainer
					? child.find(self.config.heightContainer)
					: child
			});
		});

		this.container.parents("." + BEM.buildElementClassname("tabs", "tab-content")).on("tab-content-active", _.bind(this.layout, this));

		this.layout();

		$(window).on("resize", _.debounce(_.bind(function() {
			var containerWidth = this.container.width();
			if (containerWidth !== this.containerWidth) {
				this.containerWidth = containerWidth;
				this.layout();
			}
		}, this)));
	}

	EqualHeights.prototype = {
		layout: function() {
			var self = this;

			this.resetLayout();

			function row(elements) {
				var _row = [], remains = [];
				var lastTop = null, topLock = false, maxHeight = null;

				_.forEach(elements, function(element) {
					var top;

					if (!topLock) {
						top = element.child.offset().top;

						if (null === lastTop) { lastTop = top; }

						if (top > lastTop) {
							topLock = true;
							remains.push(element);
						} else {
							maxHeight = Math.max(maxHeight, element.child.height());
							_row.push(element);
						}
					} else {
						remains.push(element);
					}
				});

				function next() {
					if (remains.length) {
						row(remains);
					}
				};

				if (_row.length > 1) {
					self.layoutRow(_row, maxHeight, next)
				} else {
					next();
				}
			}

			row(this.elements);

			this.container.trigger("gigaset.content.change");
		},

		layoutRow: function(row, targetHeight, next) {
			_.forEach(row, function(element) {
				var height = element.child.height();
				var diff = targetHeight - height;

				if (!diff) return;

				element.heightContainer.height(element.heightContainer.height() + diff);
			});

			next();
		},

		resetLayout: function() {
			_.forEach(this.elements, function(element) {
				element.heightContainer.css("height", "");
			})
		}
	};


	return Component.create({
		$init: function() {
			$(COMPONENT_SELECTOR).each(function() {
				var container = $(this),
					instance = container.data(COMPONENT_INSTANCE_KEY);

				if (!instance) {
					instance = new EqualHeights(container, container.data(COMPONENT_CONFIG_KEY));
					container.data(COMPONENT_INSTANCE_KEY, instance);
				}
			});
		}
	});
});
